import { ArrowRightCircleIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

import { skills } from "../../data/skills";

type SkillsType = {
  id: number;
  title: string;
  desc: string;
  isExpanded: boolean;
  image: string;
  content: string[];
};
type Props = {
  theme: boolean;
};

export default function Skills({ theme }: Props) {
  const [skillsExpandable, setSkillsExpandable] =
    useState<SkillsType[]>(skills);


  const handleExpandable = async (
    e: React.MouseEvent<HTMLDivElement>,
    id: number
  ) => {
    await setSkillsExpandable(
      skillsExpandable.map((p) =>
        p.id === id
          ? { ...p, isExpanded: !p.isExpanded }
          : { ...p, isExpanded: false }
      )
    );
  };

  return (
    <section
      id="skills"
      className={` projects-section-inset ${
        !theme ? "bg__skills" : "bg-gray-800"
      }`}
    >
      <div className="py-10 mx-auto w-10/12 sm:w-11/12 md:w-4/5 lg:w-8/12 xl:w-7/12">
        <div className="text-center mb-7">
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-dark dark:text-white mb-4">
            Skills &amp; Technologies
          </h1>
          <p className="leading-relaxed text-gray-800 dark:text-gray-400  xl:w-2/4 lg:w-3/4 mx-auto">
            Writing clean and organized code for better readability and search
            engine performance following the newest ES6 features and
            functionalities.
          </p>
        </div>
        <div className="flex flex-wrap">
          {skillsExpandable.map((skill) => (
            <div key={skill.title} className={`p-2 md:w-1/2 w-full self-start`}>
              <div   onClick={(e) => {
                        handleExpandable(e, skill.id);
                      }}
                className={`bg-gradient-to-r from-indigo-200 to-indigo-300 dark:from-gray-900 dark:to-gray-900  rounded p-1 h-full items-center `}
              >
                <div className={`flex p-3 bg-white dark:bg-gray-900`}>
                  <div>
                    <ArrowRightCircleIcon
                    
                      className={`text-green-400 w-6 h-6 flex-shrink-0 mr-4 cursor-pointer ${
                        skill.isExpanded ? "rotate" : ""
                      }`}
                    />
                    {skill.isExpanded && (
                      <div className="image-folder">
                        <div className="w-14 h-14 sm:w-14 sm:h-14 my-6 mt-10 ml-1 lg:ml-6 d-flex">
                          <img
                            src={require(`../../${
                              skill.id !== 8
                                ? skill.image
                                : theme
                                ? skill.image.split("|")[1]
                                : skill.image.split("|")[0]
                            }`)}
                            className="w-full"
                            alt="logo"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className=" basis-3/4 grow">
                    <div>
                      <p
                        className={`title-font font-medium mr-5 text-dark dark:text-white ${
                          skill.isExpanded ? "text-end" : ""
                        }`}
                      >
                        {skill.title}
                      </p>
                      {skill.isExpanded && (
                        <ul className="mt-6 ml-1 lg:ml-10 sm:ml-10 md:ml-6 list-outside">
                          {skill.content.map((c, index) => (
                            <li
                              key={index}
                              className="mb-1 text-dark dark:text-white"
                            >
                              <svg
                                className="w-4 h-4 inline text-green-500 dark:text-green-400 flex-shrink-0"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>{" "}
                              {c}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
